import { db } from "../../../../mp-database"
import { initSubtest } from "."

/**
 * Adds assessmentSet and subtest set data to uA object using
 * data from sets collection.
 * @param {string} assessmentSetId the set id of the assessment
 * @returns {object} {assessmentSet, assessmentSubtests} objects
 */
export default function addAssessmentSets(assessmentSetId) {
  let assessmentSet,
    assessmentSubtests = {}

  return db
    .collection("sets")
    .doc(assessmentSetId)
    .get()
    .then(doc => {
      if (!doc.exists) return []

      assessmentSet = doc.data()
      const subtestIds = getActiveSubtests(assessmentSet.content)
      const fetchSubtests = subtestIds.map(id => {
        return db.collection("sets").doc(id).get()
      })
      return Promise.all(fetchSubtests)
    })
    .then(results => {
      results.forEach(doc => {
        const subtest = doc.data()
        const id = doc.id
        const { index } = assessmentSet.content[id]
        if (subtest?.displayName) {
          assessmentSubtests[id] = initSubtest(subtest, index)
        } else {
          console.error(`Subtest ${id} missing displayName`)
        }
      })
      return { assessmentSet, assessmentSubtests }
    })
}

// returns array of active subtestId strings
function getActiveSubtests(content) {
  let subtestIds = []
  Object.keys(content).forEach(id => {
    if (content[id] && content[id].active) {
      subtestIds.push(id)
    }
  })
  return subtestIds
}
